import { buildGoalTaskCustomOrder } from '@griply/utils';
import { useMemo } from 'react';
import { Goal } from 'shared/types/goal';
import { TaskGroupBy } from 'shared/types/sorting-mode';

export const useGoalCustomOrderByGrouping = (
  groupBy: TaskGroupBy | undefined | null,
  goal?: Goal,
  subGoals: Goal[] = [],
) =>
  useMemo(
    () => buildGoalTaskCustomOrder(groupBy, goal, subGoals),
    [groupBy, goal, subGoals],
  );
